module.exports = __webpack_public_path__ + "img/logo.39fc1d17.png";